import request from '@/utils/request'


// 查询商家提现列表
export function listMerchantWithdraw(query) {
  return request({
    url: '/biz/admin/merchant/withdraw/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家提现分页
export function pageMerchantWithdraw(query) {
  return request({
    url: '/biz/admin/merchant/withdraw/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家提现详细
export function getMerchantWithdraw(data) {
  return request({
    url: '/biz/admin/merchant/withdraw/detail',
    method: 'get',
    params: data
  })
}

// 新增商家提现
export function addMerchantWithdraw(data) {
  return request({
    url: '/biz/admin/merchant/withdraw/balance',
    method: 'post',
    data: data
  })
}

// 修改商家提现
export function updateMerchantWithdraw(data) {
  return request({
    url: '/biz/admin/merchant/withdraw/edit',
    method: 'post',
    data: data
  })
}

// 删除商家提现
export function delMerchantWithdraw(data) {
  return request({
    url: '/biz/admin/merchant/withdraw/delete',
    method: 'post',
    data: data
  })
}
